import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router'
import { useAuthStore } from '@/stores'
import { useCurrentUser } from '@/hooks/api'
import { PageLoader } from '@/components/loading'

interface AuthGuardProps {
  children?: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const user = useAuthStore((state) => state.user)
  const facility = useAuthStore((state) => state.facility)
  const setAuth = useAuthStore((state) => state.setAuth)
  const location = useLocation()

  const { data: currentUserData, isLoading } = useCurrentUser()

  useEffect(() => {
    if (currentUserData?.user && currentUserData?.facility) {
      setAuth(currentUserData.user, currentUserData.facility)
    }
  }, [currentUserData, setAuth])

  if (isLoading) {
    return <PageLoader />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (user && !user.emailVerified) {
    return <Navigate to="/verify-email-pending" replace />
  }

  if (facility?.status === 'ONBOARDING' || facility?.status === 'SUSPENDED') {
    return <Navigate to="/payment" replace />
  }

  return children ? <>{children}</> : <Outlet />
}
